import { lazy } from "lazy-var";

const lazyHappy = lazy(async () => {
    const happy = await import("../../../scripts/happy.js");
    const happyMethods = await import("../../../scripts/happy.methods.js");
    return { happy, happyMethods };
});

export async function getHappy() {
    return await lazyHappy.get();
}
